import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const DropDetailPage = lazy(
  () =>
    import('./DropDetailPage.eager').then(mod => ({
      default: mod.DropDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
